// Auto-add $20 gift card when $100 gift card is added
(function() {
  const TRIGGER_VARIANT_ID = '41952800243799'; // $100 Gift Card
  const AUTO_ADD_VARIANT_ID = '42424068145239'; // $20 Gift Card
  
  // Listen for cart updates
  document.addEventListener('DOMContentLoaded', function() {
    // Intercept form submissions for add to cart
    document.addEventListener('submit', function(e) {
      const form = e.target;
      
      // Check if this is an add to cart form
      if (form.getAttribute('action') === '/cart/add' || 
          form.querySelector('[name="id"]')) {
        
        const variantId = form.querySelector('[name="id"]')?.value;
        
        // If the trigger variant is being added
        if (variantId === TRIGGER_VARIANT_ID) {
          e.preventDefault();
          
          // First add the original product
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: TRIGGER_VARIANT_ID,
              quantity: 1
            })
          })
          .then(response => response.json())
          .then(() => {
            // Then automatically add the second product
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: AUTO_ADD_VARIANT_ID,
                quantity: 1
              })
            });
          })
          .then(response => response.json())
          .then(() => {
            // Refresh the cart or redirect to cart page
            window.location.href = '/cart';
          })
          .catch(error => {
            console.error('Error adding products:', error);
          });
        }
      }
    });
  });
})();
